<template>
    <div>
        <!-- <Label> {{ $t("configurator.set_meeting_duration") }}</Label> -->
        <!-- <div class="mt-2 grid grid-cols-4 gap-4">
            <Button
                v-for="dur in knownDurations"
                :key="dur"
                variant="outline"
                :class="[
                    dur === duration
                        ? 'border-none bg-z-primary-25 text-iron-700 shadow-md ring-2 ring-z-primary-500'
                        : 'text-iron-600 shadow-xs',
                ]"
                @click="duration = dur"
                >{{ dur }} min
            </Button>
        </div> -->

        <div class="flex gap-4">
            <!-- <Button
                v-if="!addingCustomDuration"
                size="sm"
                class="mt-4 text-z-primary-600"
                variant="ghost"
                @click="addCustomDuration"
            >
                <Plus :size="20" class="mr-1 text-z-primary-500" />
                <span class="text-sm">
                    {{ $t("configurator.add_custom_duration") }}</span
                >
            </Button> -->

            <div class="w-1/2">
                <div>
                    <Label>{{ $t("configurator.custom_duration") }}</Label>

                    <InputWithSuffix
                        v-model:model-value="duration"
                        class="mt-1"
                        type="number"
                        :min="1"
                    >
                        min
                    </InputWithSuffix>
                </div>
            </div>

            <div class="w-1/2">
                <Label>{{ $t("configurator.breaks_between_slots") }}</Label>

                <InputWithSuffix
                    v-model:model-value="breaksBetweenSlots"
                    class="mt-1"
                    type="number"
                    :min="0"
                >
                    min
                </InputWithSuffix>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { EventType } from "../../../types/EventType";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import InputWithSuffix from "@/components/ui/input/InputWithSuffix.vue";
import { ref, computed, onMounted } from "vue";
import { Plus } from "lucide-vue-next";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import { debouncedWatch } from "@vueuse/core";

const props = defineProps<{
    eventType: EventType;
}>();

const duration = ref(props.eventType.duration);
const breaksBetweenSlots = ref(props.eventType.offset);

const knownDurations = ref([30, 60, 90, 120]);
const addingCustomDuration = ref(false);

function addCustomDuration() {
    addingCustomDuration.value = true;
}

debouncedWatch(
    [duration, breaksBetweenSlots],
    () => {
        change();
    },
    { debounce: 500 },
);

function change() {
    router.post(
        route("app.event-types.availability-settings", props.eventType.id),
        {
            duration: duration.value,
            offset: breaksBetweenSlots.value,
        },
    );
}
</script>
